import { useMutation, useQueryClient } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { errorToast } from 'lib/components/toasts/error';
import { EXPRESS_API } from 'configs/api/expressApi';
import { teleprompterKeys } from './queryKeys';
import { useTranslation } from 'react-i18next';

export interface CreateTeleprompterScriptRequest {
  title: string;
  content: string;
  sharedWithCompany?: boolean;
}

export interface CreateTeleprompterScriptParams {
  data: CreateTeleprompterScriptRequest;
}

export const createScript = async ({
  data,
}: CreateTeleprompterScriptParams) => {
  const response = await EXPRESS_API.post(`/teleprompter`, data);
  return response.data;
};

export const useCreateTeleprompterScriptMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation(createScript, {
    onSuccess: () => {
      queryClient.invalidateQueries(teleprompterKeys.scripts());
      successToast({
        title: t('Successfully saved script!'),
      });
    },
    onError: () => {
      errorToast({ title: t('An error occurred while creating script.') });
    },
  });
};
